var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.332 6.66927L9.66537 6.66927L9.66537 10.1693L8.33203 8.83594L7.16537 10.0026L10.4987 13.3359L13.832 10.0026L12.6654 8.83594L11.332 10.1693L11.332 6.66927ZM10.4987 1.66927C11.6515 1.66927 12.7348 1.88816 13.7487 2.32594C14.7626 2.76316 15.6445 3.35677 16.3945 4.10677C17.1445 4.85677 17.7381 5.73872 18.1754 6.7526C18.6131 7.76649 18.832 8.84983 18.832 10.0026C18.832 11.1554 18.6131 12.2387 18.1754 13.2526C17.7381 14.2665 17.1445 15.1484 16.3945 15.8984C15.6445 16.6484 14.7626 17.2423 13.7487 17.6801C12.7348 18.1173 11.6515 18.3359 10.4987 18.3359C9.34592 18.3359 8.26259 18.1173 7.2487 17.6801C6.23481 17.2423 5.35286 16.6484 4.60286 15.8984C3.85286 15.1484 3.25925 14.2665 2.82203 13.2526C2.38425 12.2387 2.16537 11.1554 2.16537 10.0026C2.16537 8.84983 2.38426 7.76649 2.82203 6.7526C3.25925 5.73871 3.85287 4.85677 4.60287 4.10677C5.35287 3.35677 6.23481 2.76316 7.2487 2.32594C8.26259 1.88816 9.34592 1.66927 10.4987 1.66927Z",
    fill: "#04DAF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleUp);
export default __webpack_public_path__ + "static/media/arrow-circle-up.a1fba9739e1bded1e02c907e55ea82d2.svg";
export { ForwardRef as ReactComponent };